import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { LoaderService } from '../../core/services/loader.service';

@Component({
  selector: 'app-global-loader',
  standalone: true,
  templateUrl: './global-loader.html',
  styleUrls: ['./global-loader.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GlobalLoaderComponent {
  readonly loader = inject(LoaderService);
}
